import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { transient } from '@lichtblick/styled';
import { Colors } from '@lichtblick/theme';
import { Frame, Progress, ProgressContainer, StrokeLeft, StrokeRight, Wrapper } from './LoadingBar.styles';
export const LoadingBar = ({ color = Colors.LightGreen, percentage })=>/*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx(Frame, {}),
            /*#__PURE__*/ _jsx(StrokeLeft, {}),
            /*#__PURE__*/ _jsx(StrokeRight, {}),
            /*#__PURE__*/ _jsx(ProgressContainer, {
                children: /*#__PURE__*/ _jsx(Progress, {
                    ...transient({
                        color,
                        percentage
                    }),
                    "data-testid": "loading-bar-progress"
                })
            })
        ]
    });

//# sourceMappingURL=LoadingBar.js.map